<template>
  <transition enter-active-class="animated fadeIn">
    <div
      :key="val"
      v-if="!edit"
      class="content is-inline"
      :class="[css, { clickable: $store.state.auth.success }]"
      @click="Edit"
      v-html="val"
    ></div>

    <Editor
      v-else
      class="has-text-black"
      :html="val"
      saveBtnName="Spara"
      saveBtnStyle="is-primary"
      cancelBtnName="Avbryt"
      cancelBtnStyle="is-default"
      :loading="isLoading"
      @save="Save($event)"
      @cancel="Cancel()"
    ></Editor>
  </transition>
</template>

<script>
import Editor from "@/components/main/Editor.vue";

export default {
  components: { Editor },
  props: ["value", "css", "page", "saveFunc"],
  data() {
    return { edit: false, isLoading: false };
  },
  mounted() {
    if (this.$store.state.auth.success) {
      if (
        typeof this.value === "object" &&
        (!this.value.value || this.value.value === "")
      ) {
        this.value.value = "<i>Text saknas</i>";
      } else if (
        typeof this.value === "string" &&
        (!this.value || this.value === "")
      ) {
        this.value = "<i>Text saknas</i>";
      }
    }
  },
  computed: {
    val: function() {
      if (this.value && typeof this.value === "object") {
        return this.value.value;
      } else {
        return this.value;
      }
    }
  },
  methods: {
    Edit(e) {
      if (this.$store.state.auth.role.level <= 2) {
        e.stopPropagation();
        e.preventDefault();
        this.edit = true;
      }
    },
    async Cancel() {
      this.$emit("cancel");
      this.$helpers.ShowStatus("Avbrutet.", 3000);
      this.edit = false;
    },
    async Save(html) {
      this.isLoading = true;

      if (this.value.value != html) {
        try {
          if (this.saveFunc || typeof this.value === "string") {
            await this.saveFunc(html);
          } else {
            await this.$helpers.SetField(this.page, this.value.name, html);
          }
          this.$helpers.ShowStatus("Sparat.", 3000);
          this.$emit("input", { ...this.value, value: html });
        } catch (err) {
          console.error(err);
        }
      } else {
        this.$helpers.ShowStatus("Inget ändrat, sparar inte.", 3000);
      }

      this.isLoading = false;
      this.edit = false;
    }
  }
};
</script>
